<template>
  <md-content class="ui-block md-elevation-2 content-cta">
    <div>
      <a href="#" data-cy="newGroupWidget" @click.prevent="openNewGroupModal">
        <div class="widget w-build-fav">
          <div class="text-center widget-inner">
            <h4 class="create-group-title">
              Build your own sharing communities
            </h4>
            <SButtonMaterial
              class="create-group-btn"
              buttonType="button"
              color="primary"
              textColor="white"
              materialClass="dense"
              text="create group"
              iconLeftText="groups"
              iconColor="white"
              @button="openNewGroupModal"
            />
          </div>
        </div>
      </a>
    </div>
  </md-content>
</template>

<script>
import { mapActions } from "vuex";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
export default {
  name: "SNewGroupWidget",
  components: {
    SButtonMaterial,
  },
  methods: {
    ...mapActions(["setNewGroupPrivacy"]),
    openNewGroupModal() {
      this.setNewGroupPrivacy(1);
      $("#create-group").modal("show");
    },
  },
};
</script>

<style lang="scss" scoped>
.create-group-title {
  font-style: normal;
  font-size: 18px;
  font-weight: 700 !important;
  line-height: 28px !important;
  text-align: center;
  letter-spacing: 1.25px;
  color: $black !important;
}
.create-group-btn {
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.4);
  margin-top: 2rem;
  height: 40px;
  font-size: 14px !important;
  border-radius: 5px;
  width: 175px;
}
.content-cta {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  background: linear-gradient(135deg, #8cccd1 50%, #a7dbdf 50%) !important;
  box-sizing: border-box;
  border-radius: 4px;
  min-width: 250px;
  max-width: 340px;
  width: 100%;
}
.ui-block {
  margin-bottom: 24px;
}
.w-build-fav {
  padding: 25px 22px 25px 22px;
  height: 200px;
  box-shadow: 0;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  &:hover {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.24);
  }
}

@media screen and (max-width: 768px) {
  .create-group-btn {
    margin-top: 4.5rem !important;
  }
}

.widget-inner {
  margin-top: 15px;
}
</style>
